export class ArrayUtils {
  public static removeDuplicates<T>(array: T[]): T[] {
    return Array.from(new Set(array));
  }
}
